import { atom } from "recoil";

export const staffDetailLogStore = atom({
	key: "staffDetailLogStore",
	default: {
		show: false,
		loaded: true,
		error: {
			text: "",
			code: 0,
			timestamp: 0,
		},
		count: 15,
		token: 0,
		data: [],
		from: 0,
		to: 0,
		pagination: {
			current: 1,
			total: 0,
		},
		currentGroupBy: null,
		currentSearch: "",
	},
});
